import { render, staticRenderFns } from "./profitFail.vue?vue&type=template&id=299cb35a&scoped=true"
import script from "./profitFail.vue?vue&type=script&lang=js"
export * from "./profitFail.vue?vue&type=script&lang=js"
import style0 from "./profitFail.vue?vue&type=style&index=0&id=299cb35a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299cb35a",
  null
  
)

export default component.exports